













import { UiTooltip } from '../../components/keen-ui';

import { FeatureIdEnum } from '../../enums';

export default {
  name: 'configuration-features-status',
  props: {
    configuration: {
      type: Object,
      required: true
    },
    featuresAvailability: {
      type: Object,
      required: true
    },
    messages: {
      type: Object,
      required: true
    }
  },
  components: {
    UiTooltip
  },
  computed: {
    features: function () {
      return {
        ...(!!this.featuresAvailability[FeatureIdEnum.FACETS_CONFIG] && !!this.configuration.facets && {
          facets: {
            name: this.messages.facets,
            icon: 'facets',
            modified: !!this.configuration.facets.elements.length
          }
        }),
        ...(!!this.featuresAvailability[FeatureIdEnum.ATTRIBUTES_RANKING] && !!this.configuration.ranking.attributes && {
          attributes: {
            name: this.messages.attributes,
            icon: 'attributes',
            modified: !!this.configuration.ranking.attributes.elements.length
          }
        }),
        ...(!!this.featuresAvailability[FeatureIdEnum.PRODUCTS_RANKING] && !!this.configuration.ranking.products && {
          products: {
            name: this.messages.products,
            icon: 'rankingactions',
            modified: !!this.configuration.ranking.products.elements.length
          }
        })
      };
    }
  }
};
